import type { TabFields } from '@/composables';

/**
 * The fields shown on each tab of the team edit form, in the order the tabs are displayed.
 * Used to highlight the tabs holding a field that failed validation.
 */
export const teamTabFields: TabFields = {
  info: [
    'name',
    'order',
    'description',
    'description_visible',
    'overseer_title',
    'overseer_user_id',
    'selected_roles',
  ],
  members: [
    'members',
  ],
};
